import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next/withAnalyticsEvents';
import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { RefAttributes } from 'react';

export const LazyLoader: LoadableType<
	Omit<
		{
			contentId: string;
			spaceKey: string;
			draftShareId: string;
			contentType: string;
		},
		keyof WithAnalyticsEventsProps
	> &
		RefAttributes<any>
> = LoadablePaint({
	loader: () => import(/* webpackChunkName: "loadable-Loader" */ './Loader.tsx'),
});
